import { Outlet, useLocation } from "react-router-dom";
import { RouteErrorBoundary } from "../components/RouteErrorBoundary";

export function AppShell() {
  const location = useLocation();
  const isHome = location.pathname === "/";
  const isCompat = location.pathname.startsWith("/compat");
  const isResult = location.pathname.startsWith("/r/");
  const isDashboard = location.pathname.startsWith("/teacher/dashboard");
  const isStudentEntry = location.pathname.startsWith("/t/");
  const title = isCompat ? "H5 兼容性检查台" : isDashboard ? "老师看板" : "AI教练学生入口";
  const phase = isCompat ? "阶段 1" : isDashboard ? "阶段 8" : "阶段 4";

  return (
    <div
      className={`app-shell ${isStudentEntry ? "student-entry-shell" : ""} ${
        isHome ? "teacher-home-shell" : ""
      }`}
    >
      {!isHome && !isStudentEntry && !isResult && !isDashboard ? (
        <header className="topbar">
          <div>
            <p className="eyebrow">迹时运动</p>
            <h1>{title}</h1>
          </div>
          <span className="build-badge">{phase}</span>
        </header>
      ) : null}
      <main>
        <RouteErrorBoundary>
          <Outlet />
        </RouteErrorBoundary>
      </main>
    </div>
  );
}
